'use client';

import React, { useState, useEffect, useCallback } from 'react';
import Cookies from 'js-cookie';
import Button from 'components/commercetools-ui/atoms/button';
import Modal from 'components/commercetools-ui/atoms/modal';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet } from 'helpers/utils/screensizes';
import {localeCountryKey} from 'helpers/constants/localeMapping';
import { useRouter } from 'next/navigation';

interface geoLocationWebsiteMismatchPopupDisplayedProps {
  locale: string;
  ipBasedAllowedLocale:string|null;
  debugString:string;
}

const GeoLocationAndWebsiteMismatchPopup: React.FC<geoLocationWebsiteMismatchPopupDisplayedProps> = ({ locale, ipBasedAllowedLocale, debugString }) => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(true);
  const closeModal = useCallback(() => setIsOpen(false), []);
  const [isTabletSize] = useMediaQuery(tablet);
  const [showPopup, setShowPopup] = useState(false);

  const userFromCountry = ipBasedAllowedLocale===localeCountryKey.au ? 'Australia':'New Zealand';
  const userOnWebsiteVersion = locale===localeCountryKey.au ? 'Australia':'New Zealand';
  const userCountryWebsiteLocaleKey = ipBasedAllowedLocale;
  //console.log('debug info for geo popup - ',debugString);
  
  useEffect(() => {
    const geoLocationAndWebsiteMismatchPopupDisplayed = Cookies.get('geo-location-and-website-mismatch-popup-displayed') ? true : false;
    let showPopupValueForConsoleDebug = false;
    if(!geoLocationAndWebsiteMismatchPopupDisplayed && ipBasedAllowedLocale && ipBasedAllowedLocale !== locale) {
      showPopupValueForConsoleDebug = true;
      setShowPopup(true);
      document.cookie = "geo-location-and-website-mismatch-popup-displayed=yes; path=/"; 
    }
    // console.log(`showPopup-${showPopupValueForConsoleDebug.toString()}  
    // geoLocationAndWebsiteMismatchPopupDisplayed-${geoLocationAndWebsiteMismatchPopupDisplayed.toString()} 
    // ipBasedAllowedLocale-${ipBasedAllowedLocale} 
    // locale-${locale}`);
  }, []);

  useEffect(() => {
    const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    const navType = navEntries[0]?.type || 'navigate';

    if (navType === 'navigate') {
      // First load (direct, typed-in, or hard refresh)
      sessionStorage.clear();
    }
  }, []);
  
  const showPopupNever = false;
  return (
    <>
    {showPopupNever &&
    <div className="fixed top-0">
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={{
        content: {
          backgroundColor: 'white',
          padding: '32px',
          top: '28%',
          maxWidth: isTabletSize ? '33.125rem' : '19.875rem',
        },
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.65)' },
      }}
    >
      <div className="flex flex-col gap-16">
        <h4 className="text-20 font-semibold text-black">Welcome from {userFromCountry}</h4>
        <p className="text-16 font-medium leading-6 text-black">
          You&apos;ve landed on the {userOnWebsiteVersion} version of our website.
        </p>
        <h4 className="text-16 font-bold leading-6 text-black">Would you like to visit our {userFromCountry} site?</h4>
        <div className="flex gap-20">
          <span className="flex flex-1 flex-col">
            <Button onClick={()=>router.push(`/${userCountryWebsiteLocaleKey}`)} className="w-full rounded-none  border border-[#2B2C39] bg-[#2B2C39] py-9 !text-14 font-medium leading-4 text-white shadow-sm hover:!border-[#394A54] hover:!bg-[#394A54]">
              Yes
            </Button>
            <span className="mt-8 text-14 font-medium leading-4 text-primary-black">
              Take me to the {userFromCountry} site
            </span>
          </span>
          <span className="flex flex-1 flex-col">
            <Button onClick={closeModal} className="w-full rounded-none  border border-[#2B2C39] bg-white py-9 !text-14 font-medium leading-4 !text-black shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4]">
              No thanks
            </Button>
            <span className="mt-8 text-14 font-medium leading-4 text-primary-black">
              I&apos;d like to stay on the {userOnWebsiteVersion} site
            </span>
          </span>
        </div>
      </div>
    </Modal>
  </div>
  }
    </>
  );
};

export default GeoLocationAndWebsiteMismatchPopup;
